import React from 'react';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section className="py-6 md:py-8 px-3 md:px-4 bg-black" data-id="element-87">
      <div className="max-w-2xl mx-auto bg-dark border border-white/10 rounded-2xl p-6 flex flex-col md:flex-row items-center gap-6 text-center md:text-left" data-id="element-88">
        <div className="bg-gradient-to-br from-rosa to-terracota p-4 rounded-full shrink-0" data-id="element-89">
          <Shield size={48} className="text-white" data-id="element-90" />
        </div>
        <div data-id="element-91">
          <h3 className="text-2xl font-black text-white uppercase mb-2" data-id="element-92">
            Garantía de 7 días
          </h3>
          <p className="text-gray-300 text-sm mb-2" data-id="element-93">
            Nuestra prioridad siempre es la{' '}
            <strong className="text-white" data-id="element-94">tranquilidad</strong> de nuestros
            clientes.
          </p>
          <p className="text-white font-semibold text-sm mb-2" data-id="element-95">
            Si no sentís más{' '}
            <strong className="text-rosa" data-id="element-96">
              claridad, control y tranquilidad
            </strong>{' '}
            te devolvemos el <strong className="text-terracota" data-id="element-97">100%</strong>.
          </p>
          <p className="text-terracota font-black uppercase tracking-widest" data-id="element-98">
            Sin vueltas.
          </p>
        </div>
      </div>
    </section>;
}